import ResponsiveHelper from "../../../../../../packages/design-system/src/ResponsiveHelper";
import LockIcon from "../../../../../../packages/design-system/src/Icons/LockIcon";
import * as React from 'react';
export default {
  ResponsiveHelper,
  LockIcon,
  React
};